/**
 * Carnet / mantenedor médico.
 */
// --- Carnet / mantenedor médico (controles, vacunas, archivos) ---
export const carnet = {
  controlsTitle: 'Controles médicos',
  controlsSubtitle: 'Historial de controles registrados para el carnet.',
  newControl: 'Nuevo control',
  attachImage: 'Adjuntar imagen',
  deleteControlTitle: 'Eliminar control médico',
  deleteControlConfirm: '¿Eliminar este control médico? Esta acción no se puede deshacer.',
  deleteVaccinationConfirm: '¿Eliminar esta vacunación? Esta acción no se puede deshacer.',
  deleteVaccinationTitle: 'Eliminar vacunación',
  deleteRecordConfirm: '¿Eliminar este registro clínico? Esta acción no se puede deshacer.',
  deleteRecordTitle: 'Eliminar registro clínico',
  deleteFileTitle: 'Eliminar archivo',
  deleteCertificateTitle: 'Eliminar certificado',
  deleteReportTitle: 'Eliminar informe',
  deleteImageTitle: 'Eliminar imagen',
  deleteCertificateMessage: '¿Estás seguro de que deseas eliminar este certificado?',
  deleteReportMessage: '¿Estás seguro de que deseas eliminar este informe?',
  deleteImageMessage: '¿Estás seguro de que deseas eliminar esta imagen?',
  deleteFileMessage: '¿Estás seguro de que deseas eliminar este archivo?',
  deleteCertificateDescription: 'Este certificado será eliminado permanentemente.',
  deleteReportDescription: 'Este informe será eliminado permanentemente.',
  deleteImageDescription: 'Esta imagen será eliminada permanentemente.',
  deleteFileDescription: 'Este archivo será eliminado permanentemente.',
  deleteGroomingTitle: 'Eliminar control de peluquería',
  deleteGroomingMessage: '¿Estás seguro de que deseas eliminar este control de peluquería?',
  deleteGroomingDescription: (max: number) =>
    `Este control será eliminado permanentemente. Solo puedes eliminar hasta ${max} controles de peluquería.`,
  groomingLabel: 'Peluquero',
  groomingSalonLabel: 'Peluquería',
  diagnosisLabel: 'Diagnóstico:',
  attachedFiles: 'Archivos adjuntos',
  documentsAssociatedControl: 'Documentos asociados a este control',
  noControlsRegistered: 'No hay controles registrados.',
  cropImageTitle: 'Recortar imagen',
  petLoadError: 'No se pudo cargar la información de la mascota.',
  backToRecord: 'Volver a la ficha',
  managerTitle: 'Mantenedor del carnet',
  managerSubtitle: 'Administra controles, vacunas, registros clínicos y adjuntos de la mascota.',
  downloadPdf: 'Descargar PDF',
  filterByYear: 'Filtrar información por año',
  filterByYearHint: 'Selecciona un año para ver controles médicos, vacunaciones y peluquerías de ese período',
  yearLabel: 'Año:',
  allYears: 'Todos los años',
  veterinarianOptional: 'Veterinario responsable (opcional)',
  loadingProfessionals: 'Cargando profesionales...',
  clinicTeamLoadError: 'No se pudo cargar el equipo de la clínica.',
  associatePetToClinicHint: 'Asocia la mascota a una clínica para registrar el responsable del control.',
  noVeterinariansInClinic: 'No hay veterinarios activos asociados a esta clínica.',
  canCreateWithoutVet: 'Puedes crear el control sin asignar un veterinario.',
  controlDiagnosisLabel: 'Diagnóstico',
  controlTreatmentPlanLabel: 'Plan de tratamiento',
  vaccinesTitle: 'Vacunas',
  vaccinesSubtitle: 'Mantenedor del historial de vacunación.',
  newVaccine: 'Nueva vacuna',
  vaccinePurposeLabel: '¿Para qué sirve?',
  vaccineFrequencyLabel: 'Frecuencia de aplicación:',
  vaccineCertificatesTitle: 'Certificados asociados',
  vaccineCertificatesSubtitle: 'Documentos de vacunación',
  noVaccinesRegistered: 'No hay vacunas registradas.',
  recordsTitle: 'Registros clínicos',
  recordsSubtitle: 'Documenta procedimientos o intervenciones.',
  newRecord: 'Nuevo registro',
  reportsAssociated: 'Informes asociados',
  procedureDocuments: 'Documentos del procedimiento',
  noRecordsRegistered: 'No hay registros clínicos.',
  // Modal agregar archivo
  addFileTitle: 'Agregar archivo',
  fileTypeLabel: 'Tipo de archivo',
  fileTypeMedicalReport: 'Informe médico',
  fileTypeVaccinationCertificate: 'Certificado de vacunación',
  fileTypeProfileImage: 'Foto de perfil',
  fileTypeOther: 'Otro',
  vaccineRelatedLabel: 'Vacuna relacionada *',
  recordRelatedLabel: 'Registro clínico relacionado *',
  selectVaccinePlaceholder: 'Selecciona una vacuna',
  selectRecordPlaceholder: 'Selecciona un registro',
  fileLabel: 'Archivo',
  uploading: 'Subiendo...',
  uploadFile: 'Subir archivo',
  fileTooLarge: 'El archivo es demasiado grande. El tamaño máximo es 10MB.',
  selectFileToUpload: 'Selecciona un archivo para subir',
  selectVaccineForCertificate: 'Selecciona la vacuna relacionada con el certificado.',
  selectRecordForReport: 'Selecciona el registro clínico relacionado con el informe.',
  editVaccineTitle: 'Editar vacuna',
  editVaccineDisabledArchived: 'No se puede editar porque está archivado',
  editControlTitle: 'Editar control',
  editControlDisabledArchived: 'No se puede editar porque está archivado',
  editRecordTitle: 'Editar registro',
  editRecordDisabledArchived: 'No se puede editar porque está archivado',
  certificateAlt: 'Certificado de vacunación',
  documentCount: (n: number) => (n === 1 ? 'documento' : 'documentos'),
  // Errores/fallbacks carnet
  invalidVaccineId: 'ID de vacuna inválido. Por favor, recarga la página e intenta nuevamente.',
  saveVaccineError: 'No se pudo guardar la vacuna',
  saveRecordError: 'No se pudo guardar el registro',
  saveGroomingError: 'No se pudo guardar el control de peluquería',
  deleteGroomingError: 'No se pudo eliminar el control de peluquería',
  deleteControlError: 'No se pudo eliminar el control médico',
  deleteVaccinationError: 'No se pudo eliminar la vacunación',
  deleteRecordError: 'No se pudo eliminar el registro clínico',
  selectFile: 'Selecciona un archivo',
  maxFilesPerPet: (max: number) =>
    `Se ha alcanzado el límite de ${max} archivos por mascota. Elimina algunos archivos antes de subir nuevos.`,
  maxFilesPerVaccination: (max: number) =>
    `Se ha alcanzado el límite de ${max} archivos por vacunación. Elimina algunos archivos antes de subir nuevos.`,
  maxFilesPerRecord: (max: number) =>
    `Se ha alcanzado el límite de ${max} archivos por registro médico. Elimina algunos archivos antes de subir nuevos.`,
  filesRemainingWarning: (n: number) =>
    `⚠️ Advertencia: Te quedan ${n} archivos disponibles para esta mascota.`,
  vaccineUpdated: 'Vacuna actualizada',
  vaccineRegistered: 'Vacuna registrada',
  recordUpdated: 'Registro actualizado',
  recordCreated: 'Registro creado',
  groomingUpdated: 'Control de peluquería actualizado',
  groomingRegistered: 'Control de peluquería registrado',
  uploadFileError: 'No se pudo subir el archivo',
  deleteFileError: 'No se pudo eliminar el archivo',
  loadingClinicalSummary: 'Cargando resumen clínico...',
  clinicalSummaryLoadError: 'No se pudo cargar el resumen clínico.',
  retry: 'Reintentar',
  archivedRecordsLoadError:
    'Error al cargar registros archivados. Algunos datos históricos pueden no estar disponibles.',
} as const;
